import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Button, Text } from "@mantine/core";
import { IconMenu2, IconX } from "@tabler/icons-react";
import brandname from "../../assets/images/Wordmark.png";
import BrandLogo from "../../assets/images/Logo.png";
import BrandLogo2 from "../../assets/images/Logo-white.png";
import { useNavigate, useLocation, Link } from "react-router-dom";

const OverAllHeaderWrapper = styled.div`
  position: fixed;
  width: 100%;
  background-color: ${(props) => (props.isHomePage ? "transparent" : "black")};
  // background-color: #000000ab;
  transition: background-color 0.3s ease;
  z-index: 100;

  &.sticky {
    background-color: black;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }
`;

const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 1rem 7%;
  position: relative;
  // border-bottom: ${(props) => (props.isSticky ? "none" : "2px solid white")};

  @media (max-width: 868px) {
    padding: 0rem;
    margin: 0rem 1rem;
    border-bottom: none;
  }

    @media (max-width: 1270px) and (min-width: 868px) {
    margin: 1rem 1%;
  }
`;

const DesktopNavLinks = styled.nav`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  margin: 0 2rem;

  @media (max-width: 868px) {
    display: none;
  }
`;

const MobileNavLinks = styled.nav`
  display: none;

  @media (max-width: 868px) {
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 3rem;
    left: 0;
    right: 0;
    background: black;
    z-index: 999;
    padding: 1rem 2rem;
    margin-top: 2rem;
  }
`;

const BurgerMenu = styled.div`
  display: none;
  color: white;

  @media (max-width: 868px) {
    display: flex;
    align-items: center;
    cursor: pointer;
  }
`;

const NavLinks = styled.div`
  display: inline-block;
  text-align: center;

  @media (max-width: 868px) {
    display: flex;
    flex-direction: column;
    margin-top: 1rem;
  }
`;

const NavLink = styled(Link)`
  font-size: 1rem;
  margin: 0 1rem;
  font-weight: 600;
  letter-spacing: 0;
  transition: all 0.3s ease;
  padding-bottom: 0.25rem;
  border-bottom: 2px solid transparent;
  text-decoration: none;
  color: white;
  font-family: "Poppins", sans-serif;

  &:hover,
  &:focus {
    border-color: #fff;
    color: rgb(167, 140, 76)!important;
  }

  @media (max-width: 868px) {
    font-size: 1.25rem;
    padding: 0.75rem 0;
    border-bottom: none;
    margin: 0.4rem 0;
  }

    @media (max-width: 1270px) and (min-width: 868px) {
    font-size: 0.7rem;
     margin: 0 0.5rem;
  }
`;

const PrimaryLink = styled(NavLink)`
  @media (min-width: 1024px) {
    margin-left: 0;
    margin-right: 0;
  }

  padding: 0.75rem 2rem;
  border-radius: 50%;
  background-color: #3b82f6;
  color: #f3f4f6;
  border-bottom: 0;

  &:hover,
  &:focus {
    background-color: #1d4ed8;
    color: #e5e7eb;
    outline: none;
    box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.6);
  }

  @media (max-width: 868px) {
    padding: 1rem;
    border-radius: 50px;
  }
`;

const LogoLink = styled(NavLink)`
  display: flex;
  align-items: center;
  font-weight: 900;
  border-bottom: 0;
  font-size: 1.5rem;
  margin: 0;

  img {
    max-width: 100%;
    max-height: 100%;
    width: 10rem;
    height: auto;

    @media (max-width: 868px) {
      width: 8rem;
    }
  }
`;

const ButtonWrapper = styled.div`
  position: relative;
  display: inline-block;
  overflow: hidden;
  border-radius: 0;
`;

const FillButton = styled(Button)`
  position: relative;
  background: rgb(167, 140, 76) !important;
  border-radius: 10px !important;
  border: 2px solid white !important;
  color: #fff !important;
  font-family: "Poppins", sans-serif !important;
  padding: 0.5rem 1rem !important;
  overflow: hidden;
  transition: background 0.3s ease, color 0.3s ease !important;
  z-index: 1;

  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: #131313 !important;
    transition: left 0.3s ease !important;
    z-index: -1;
  }

  @media (max-width: 1270px) and (min-width: 868px) {
    padding: 0.5rem 0rem !important;
  }

  &:hover {
    background: #000 !important;
    color: #fff !important; /* To ensure text remains visible */
  }

  &:hover:before {
    left: 0 !important;
  }

  i {
    margin-left: 0.5rem !important;
    font-size: 1rem !important;
    transition: color 0.3s ease !important;
  }

  &:hover i {
    color: #fff !important;
  }
`;


const ContactButtonContainer = styled.div`
  position: "relative";
  right: 7rem;

  @media (max-width: 868px) {
    display: none;
  }
`;

const NavBar = () => {
  const [isSticky, setIsSticky] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const isAuthenticated = localStorage.getItem("isAuthenticated") === "embark#@1999$33";
  const location = useLocation();
  const isHomePage = location.pathname === "/";
  const handleScroll = () => {
    if (window.scrollY > 0) {
      setIsSticky(true);
    } else {
      setIsSticky(false);
    }
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleLogout = () => {
    localStorage.removeItem("isAuthenticated");
    navigate("/");
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <OverAllHeaderWrapper
      className={isSticky ? "sticky" : ""}
      isHomePage={isHomePage}
    >
      <Header isSticky={isSticky} isHomePage={isHomePage}>
        <LogoLink to="/">
          <img style={{ width: "6rem" }} src={BrandLogo2} alt="logo" />
        </LogoLink>
        <DesktopNavLinks>
          <NavLinks>
            {/* <NavLink to="/about"> Our Story </NavLink> */}
            <NavLink to="/"> Home </NavLink>
            <NavLink to="/services"> Services </NavLink>
            <NavLink to="/projects"> New Launchs </NavLink>
            <NavLink to="/mortgage"> Mortgage </NavLink>
            <NavLink to="/career"> Career </NavLink>
            <NavLink to="/team"> Team </NavLink>
            <NavLink to="/articles"> Market Insights </NavLink>
            {/* {isAuthenticated && <NavLink onClick={handleLogout}>Logout</NavLink>} */}
          </NavLinks>
        </DesktopNavLinks>
        <ContactButtonContainer>
          <ButtonWrapper>
            <Link to="/contact">
              <FillButton size="md">
                <Text className="book-appointment-btn" style={{ zIndex: 1 }}>
                  Book an Appointment{" "}
                  <i className="fa-solid fa-chevron-right"> </i>
                </Text>
              </FillButton>
            </Link>
          </ButtonWrapper>
        </ContactButtonContainer>
        <BurgerMenu onClick={toggleMenu}>
          {isMenuOpen ? (
            <IconX size={24} color="white" />
          ) : (
            <IconMenu2 size={24} color="white" />
          )}
        </BurgerMenu>
        {isMenuOpen && (
          <MobileNavLinks>
            <NavLinks>
              {/* <NavLink onClick={toggleMenu} to="/about"> Our Story </NavLink> */}
               <NavLink onClick={toggleMenu} to="/"> Home </NavLink>
              <NavLink onClick={toggleMenu} to="/services"> Services </NavLink>
              <NavLink onClick={toggleMenu} to="/projects"> New Launchs </NavLink>
              <NavLink onClick={toggleMenu} to="/mortgage"> Mortgage </NavLink>
              <NavLink onClick={toggleMenu} to="/team"> Team </NavLink>
              <NavLink onClick={toggleMenu} to="/career"> Career </NavLink>
              <NavLink onClick={toggleMenu} to="/articles"> Market Insights </NavLink>
            </NavLinks>
            <NavLinks>
              <ButtonWrapper>
                <Link to="/contact">
                  <FillButton size="md" color="white">
                    <Text style={{ zIndex: 1, color: "white" }}>
                    Book an Appointment <i className="fa-solid fa-chevron-right"> </i>
                    </Text>
                  </FillButton>
                </Link>
              </ButtonWrapper>
            </NavLinks>
          </MobileNavLinks>
        )}
      </Header>
    </OverAllHeaderWrapper>
  );
};

export default NavBar;
